var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", _vm._g({ staticClass: "app-icon" }, _vm.$listeners), [
    _c(
      "svg",
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: _vm.icon.viewBox,
          "aria-labelledby": _vm.iconName,
          role: "presentation"
        }
      },
      [
        _c("title", { attrs: { id: _vm.iconName, lang: "en" } }, [
          _vm._v("\n\t\t\t" + _vm._s(_vm.iconName) + " icon\n\t\t")
        ]),
        _vm._v(" "),
        _c(
          "g",
          { attrs: { fill: _vm.iconColor } },
          [
            _vm._t("default", [
              _vm.iconName
                ? _c("path", {
                    attrs: { d: _vm.icon.d, transform: _vm.icon.transform }
                  })
                : _vm._e()
            ])
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-002996dd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-002996dd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppIcon.vue
// module id = null
// module chunks = 